import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import "rc-slider/assets/index.css";
import Slider from "rc-slider";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import WindowOutlinedIcon from "@mui/icons-material/WindowOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import RestartAltOutlinedIcon from "@mui/icons-material/RestartAltOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import FilterListIcon from "@mui/icons-material/FilterList";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { _Api, Api_form } from "../api/_call";
import DeleteModal from "../common/modules/deletemodal";
import TableColumnModal from "../common/modules/tableColumn";
import { ImportExcelModal } from "../common/modules/importExcel";
import SocialModal from "../common/modules/SocialModal/SocialModal";
import { Pagination } from "../common/Pagination";
import {
  success,
  error,
  loading,
  Updateloading,
} from "../common/helpers/toastify";
import { formatDate } from "../common/helpers/formatDate";
import "./colorStone.scss";
import "./ColorStoneSearchPage.scss";
import DeallocateModal from "./DeallocateModal";

const DEFAULT_PAGE_SIZE = 100;
const PAGE_SIZE_OPTIONS = [100, 200, 300].map((n) => ({ label: n, value: n }));

const EMPTY_SELECTION = {
  shape: [],
  color: [],
  clarity: [],
  cut: [],
  lab: [],
  status: [],
  location: [],
};

const VIDEO_URL_PATTERN = /\.(mp4|mov|webm|ogg|m4v)(\?|$)/i;

const mediaUrl = (m) =>
  typeof m === "string" ? m : m?.url || m?.image || m?.path || "";

const mediaList = (value) =>
  (Array.isArray(value) ? value : [value]).map(mediaUrl).filter(Boolean);

const previewMediaOf = (record) => {
  if (!record) return "";
  const images = mediaList(record.image);
  const videos = mediaList(record.video);
  if (mediaUrl(record.DefaultMedia)) return mediaUrl(record.DefaultMedia);
  if (String(record.DefaultMediaType).toLowerCase() === "video" && videos[0])
    return videos[0];
  return (
    mediaUrl(record.DefaultImage) ||
    mediaUrl(record.defaultImage) ||
    images[Number(record.DefaultImageIndex) || 0] ||
    images[0] ||
    videos[0] ||
    ""
  );
};

const renderPreviewMedia = (url, alt) =>
  VIDEO_URL_PATTERN.test(url) ? (
    <video className="is-media" src={url} autoPlay muted loop playsInline />
  ) : (
    <img className="is-media" src={url} alt={alt} />
  );

const categoryText = (record, field = "Category_name") => {
  const category = record?.Category;
  if (category && !Array.isArray(category) && typeof category === "object") {
    return (
      category.value ||
      category.key ||
      category[field] ||
      category.name ||
      category.label ||
      ""
    );
  }
  const list = Array.isArray(category) ? category : [];
  const fromList = list
    .map((c) =>
      c && typeof c === "object"
        ? c.value || c.key || c[field] || c.name || c.label
        : "",
    )
    .filter(Boolean);
  return fromList.length ? fromList.join(", ") : (record?.[field] ?? "");
};

// const customJewelryNames = (record) => {
//   const list = Array.isArray(record?.CustomJewelry)
//     ? record.CustomJewelry
//     : record?.CustomJewelry
//       ? [record.CustomJewelry]
//       : [];
//   return list
//     .map((c) => {
//       if (c && typeof c === 'object') {
//         return c.Category_name || c.name || c.label || c.CustomJewelry_name || '';
//       }
//       return c == null ? '' : String(c);
//     })
//     .filter(Boolean);
// };

// const customJewelryText = (record) => customJewelryNames(record).join(', ');

// const customJewelryPreview = (record, limit = 3) => {
//   const names = customJewelryNames(record);
//   if (names.length <= limit) return names.join(', ');
//   return `${names.slice(0, limit).join(', ')}...`;
// };

const COLUMN_STORAGE_KEY = "ColorStoneSearchColumns";

const COLUMN_KEYS = [
  "status",
  "img",
  "stone",
  "category",
  "size",
  "shape",
  "weight",
  "colour",
  "clarity",
  "cut",
  "origin",
  "treatment",
  "grade",
  "certification",
  "stockId",
  "price",
  "location",
];

const FIXED_COLUMN_KEYS = [
  "status",
  "img",
  "stone",
  "shape",
  "weight",
  "colour",
  "clarity",
  "cut",
  "treatment",
  "grade",
  "certification",
  "stockId",
  "price",
  "location",
];

const isFixedColumn = (key) => FIXED_COLUMN_KEYS.includes(key);

const loadColumnPrefs = () => {
  let saved = [];
  try {
    saved = JSON.parse(localStorage.getItem(COLUMN_STORAGE_KEY)) || [];
  } catch (err) {
    saved = [];
  }
  const known = saved.filter((c) => COLUMN_KEYS.includes(c?.key));
  const missing = COLUMN_KEYS.filter(
    (key) => !known.some((c) => c.key === key),
  ).map((key) => ({
    key,
    visible: true,
  }));
  return [
    ...known.map((c) => ({ key: c.key, visible: c.visible !== false })),
    ...missing,
  ];
};

const toPriceNumber = (value) => {
  const n = Number(String(value ?? "").replace(/[^0-9.-]/g, ""));
  return Number.isFinite(n) ? n : 0;
};

const sumPrices = (list) =>
  list.reduce((total, item) => total + toPriceNumber(item?.Price), 0);

const formatPrice = (value) => {
  if (value === undefined || value === null || value === "") return "";
  return `$${toPriceNumber(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const STATUS_META = {
  1: { label: "Stock", className: "is-stock" },
  2: { label: "Reserve", className: "is-reserve" },
  3: { label: "Custom Order", className: "is-custom" },
  4: { label: "Transit", className: "is-transit" },
};

const TRANSIT_STATUS = 4;

const idsOf = (list) => (list || []).map((item) => item?._id);
const pickSelected = (selected, all) => (selected?.length ? selected : all);
const toRange = (range) => [Number(range?.min) || 0, Number(range?.max) || 0];
const formatRangeDate = (date) =>
  date
    ? date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

// const toApiDate = (date) => {
//   const pad = (n) => String(n).padStart(2, '0');
//   return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
// };
const toApiDate = (date) => {
  const now = new Date();
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds(),
  ).toISOString();
};

const formatInputDate = (date) => {
  if (!date) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
};

const parseInputDate = (text) => {
  const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(String(text).trim());
  if (!match) return null;
  const [, d, m, y] = match.map(Number);
  const date = new Date(y, m - 1, d);
  return date.getDate() === d && date.getMonth() === m - 1 ? date : null;
};

const OLD_DATE_PRESETS = [
  ["Show All", "Show All"],
  ["Today", "Today"],
  ["Yesterday", "Yesterday"],
  ["7days", "Last 7 Days"],
  ["30days", "Last 30 Days"],
  ["ThisMonth", "This Month"],
  ["LastMonth", "Last Month"],
  ["Custom Range", "Custom Range"],
];

const DATE_PRESETS = [
  ["Today", "Today"],
  ["Yesterday", "Yesterday"],
  ["7days", "Last 7 days"],
  ["30days", "Last 30 days"],
  ["ThisMonth", "This month"],
  ["LastMonth", "Last month"],
  ["ThisYear", "This year"],
  ["Show All", "Show All"],
];

const ColorStoneSearch = () => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);

  const [filters, setFilters] = useState(null);
  const [sel, setSel] = useState(EMPTY_SELECTION);
  const [price, setPrice] = useState([0, 0]);
  const [carat, setCarat] = useState([0, 0]);
  // const [startdate, setStartdate] = useState(() => {
  //   const today = new Date();
  //   return new Date(today.getFullYear(), today.getMonth(), today.getDate());
  // });
  // const [enddate, setEnddate] = useState(() => {
  //   const today = new Date();
  //   return new Date(today.getFullYear(), today.getMonth() + 1, 0);
  // });
  // const [datelable, setDatelable] = useState('Custom Range');
  // const [startdate, setStartdate] = useState(null);
  // const [enddate, setEnddate] = useState(null);
  // const [datelable, setDatelable] = useState('Show All');
  // const [startdate, setStartdate] = useState(
  //   () => new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  // );
  // const [enddate, setEnddate] = useState(
  //   () => new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
  // );
  // const [datelable, setDatelable] = useState('ThisMonth');
  const [startdate, setStartdate] = useState(null);
  const [enddate, setEnddate] = useState(null);
  const [datelable, setDatelable] = useState("Show All");
  const [customRangeOpen, setCustomRangeOpen] = useState(false);

  const [items, setItems] = useState([]);
  const [totalresult, setTotalresult] = useState(0);
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(DEFAULT_PAGE_SIZE);
  const resultsRef = useRef(null);
  const [stats, setStats] = useState({});
  const [comparison, setComparison] = useState([]);
  const [activeTab, setActiveTab] = useState("results");
  const [viewMode, setViewMode] = useState("table");
  const [searchText, setSearchText] = useState("");

  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [showAnalytics, setShowAnalytics] = useState(true);
  const [moreActionsOpen, setMoreActionsOpen] = useState(false);
  const [dateMenuOpen, setDateMenuOpen] = useState(false);
  const [limitMenuOpen, setLimitMenuOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState("reserve");
  const [draftStart, setDraftStart] = useState(null);
  const [draftEnd, setDraftEnd] = useState(null);
  const [startText, setStartText] = useState("");
  const [endText, setEndText] = useState("");

  const [importfile, setImportfile] = useState();
  const [socialurl, setSocialurl] = useState();
  const [shareloader, setShareloader] = useState(false);
  const [colorStoneExportFormat, setColorStoneExportFormat] = useState("xlsx");
  const [colorStoneSampleFormat, setColorStoneSampleFormat] = useState("xlsx");
  const [detailId, setDetailId] = useState(null);
  const [details, setDetails] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [columnPrefs, setColumnPrefs] = useState(loadColumnPrefs);
  const [columnsMenuOpen, setColumnsMenuOpen] = useState(false);
  const [draggingColumn, setDraggingColumn] = useState(null);
  const [certMenu, setCertMenu] = useState(null);
  const [certChoice, setCertChoice] = useState({});
  const columnsBtnRef = useRef(null);
  const columnsMenuRef = useRef(null);

  useEffect(() => {
    localStorage.setItem(COLUMN_STORAGE_KEY, JSON.stringify(columnPrefs));
  }, [columnPrefs]);

  useEffect(() => {
    if (!columnsMenuOpen) return undefined;
    const handleClickOutside = (e) => {
      if (
        !columnsMenuRef.current?.contains(e.target) &&
        !columnsBtnRef.current?.contains(e.target)
      ) {
        setColumnsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [columnsMenuOpen]);

  const moreActionsRef = useRef(null);
  const detailRequestRef = useRef(0);
  const dateMenuRef = useRef(null);
  const limitSelectRef = useRef(null);
  const requestIdRef = useRef(0);
  const isFirstDateRun = useRef(true);
  const latest = useRef({});
  // latest.current = { filters, sel, price, carat, startdate, enddate, limit };
  latest.current = {
    filters,
    sel,
    price,
    carat,
    startdate,
    enddate,
    limit,
    datelable,
  };

  const buildPayload = (skipCount, overrides = {}) => {
    const s = { ...latest.current, ...overrides };
    const payload = {
      limit: s.limit,
      skip: skipCount,
    };
    if (s.startdate && s.enddate) {
      payload.start_date = toApiDate(s.startdate);
      payload.end_date = toApiDate(s.enddate);
    }
    return payload;
  };

  const fetchList = async (skipCount = 0, overrides = {}) => {
    // Color stone has no getFilters API — allow list fetch with empty filters
    const requestId = ++requestIdRef.current;
    try {
      const res = await _Api(
        buildPayload(skipCount, overrides),
        `api/v1/Inventory/colorStone/getList`,
      );
      if (requestId !== requestIdRef.current) return;
      if (res?.code === 200) {
        setItems(res.data || []);
        setTotalresult(Number(res.totalResult) || 0);
        setSkip(skipCount);
        setStats({
          freeStock: res?.freeStock ?? 0,
          reserve: res?.reserve ?? res?.reserveCount ?? 0,
          locations: res?.locations ?? res?.locationCount ?? 0,
          reorderQuantity: res?.reorderQuantity ?? 0,
        });
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const EMPTY_FILTERS = {
    filters: {},
    sel: EMPTY_SELECTION,
    price: [0, 0],
    carat: [0, 0],
  };

  const resetAndFetchList = () => {
    setFilters(EMPTY_FILTERS.filters);
    setSel(EMPTY_SELECTION);
    setPrice(EMPTY_FILTERS.price);
    setCarat(EMPTY_FILTERS.carat);
    setComparison([]);
    setSearchText("");
    fetchList(0, EMPTY_FILTERS);
  };

  useEffect(() => {
    resetAndFetchList();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isFirstDateRun.current) {
      isFirstDateRun.current = false;
      return;
    }
    if (startdate && !enddate) return;
    fetchList(0);
    // eslint-disable-next-line
  }, [startdate, enddate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        moreActionsRef.current &&
        !moreActionsRef.current.contains(event.target)
      ) {
        setMoreActionsOpen(false);
      }
      if (dateMenuRef.current && !dateMenuRef.current.contains(event.target)) {
        setDateMenuOpen(false);
        setCustomRangeOpen(false);
      }
      if (
        limitSelectRef.current &&
        !limitSelectRef.current.contains(event.target) &&
        !event.target.closest?.(".ds-limit__menu")
      ) {
        setLimitMenuOpen(false);
      }
      if (
        !event.target.closest?.(".ds-cert-pop") &&
        !event.target.closest?.(".ds-cert-btn")
      ) {
        setCertMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleSelection = (key, value) => {
    const current = latest.current.sel[key] || [];
    const nextList = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    const nextSel = { ...latest.current.sel, [key]: nextList };
    setSel(nextSel);
    fetchList(0, { sel: nextSel });
  };

  const rangeSetters = { price: setPrice, carat: setCarat };

  const commitRange = (key, value) => {
    const bounds = toRange(
      { price: filters?.Price, carat: filters?.Carat }[key],
    );
    const clamp = (n) =>
      Math.min(Math.max(Number(n) || 0, bounds[0]), bounds[1]);
    const next = [clamp(value[0]), clamp(value[1])].sort((a, b) => a - b);
    rangeSetters[key](next);
    fetchList(0, { [key]: next });
  };

  const totalPages = Math.max(1, Math.ceil(Number(totalresult) / limit));
  const currentPage = Math.floor(skip / limit) + 1;

  const goToPage = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages || pageNumber === currentPage)
      return;
    fetchList((pageNumber - 1) * limit);
    resultsRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const changeLimit = (nextLimit) => {
    setLimit(nextLimit);
    fetchList(0, { limit: nextLimit });
  };

  const changeDates = (lable) => {
    const today = new Date();
    let start = null;
    let end = null;
    if (lable === "Today") {
      start = new Date();
      end = new Date();
    } else if (lable === "Yesterday") {
      start = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 1,
      );
      end = start;
    } else if (lable === "7days") {
      start = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 7,
      );
      end = new Date();
    } else if (lable === "30days") {
      start = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 30,
      );
      end = new Date();
    } else if (lable === "ThisMonth") {
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    } else if (lable === "LastMonth") {
      start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      end = new Date(today.getFullYear(), today.getMonth(), 0);
    } else if (lable === "ThisYear") {
      start = new Date(today.getFullYear(), 0, 1);
      end = new Date(today.getFullYear(), 11, 31);
    } else if (lable === "Show All") {
      // start = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
      // end = new Date();
      start = null;
      end = null;
    }
    setStartdate(start);
    setEnddate(end);
    setDatelable(lable);
    setDateMenuOpen(false);
  };

  const syncDraft = (start, end) => {
    setDraftStart(start);
    setDraftEnd(end);
    setStartText(formatInputDate(start));
    setEndText(formatInputDate(end));
  };

  const toggleDateMenu = () => {
    if (!dateMenuOpen) syncDraft(startdate, enddate);
    setDateMenuOpen((o) => !o);
  };

  const applyCustomRange = (start, end) => {
    const [from, to] = start <= end ? [start, end] : [end, start];
    setStartdate(from);
    setEnddate(to);
    setDatelable("Custom Range");
    setDateMenuOpen(false);
  };

  const commitTypedDate = (which) => {
    const parsed = parseInputDate(which === "start" ? startText : endText);
    if (!parsed) {
      syncDraft(draftStart, draftEnd);
      return;
    }
    const nextStart = which === "start" ? parsed : draftStart;
    const nextEnd = which === "end" ? parsed : draftEnd;
    syncDraft(nextStart, nextEnd);
    if (nextStart && nextEnd) applyCustomRange(nextStart, nextEnd);
  };

  const readExcel = async () => {
    if (!importfile) {
      error(t("Choose file!"));
      return;
    }
    try {
      const formData = new FormData();
      formData.append("file", importfile);
      formData.append("type", "ColorStoneImport");
      const res = await Api_form(
        formData,
        `api/v1/Inventory/colorStone/uploadColorStonexls`,
      );
      if (res.code === 200) {
        success(
          t(
            "File Sucessfully Uploaded and Backend Process have  Started Now,Please wait!!",
          ),
        );
        setImportfile(null);
        resetAndFetchList();
      } else {
        error(
          res?.message ||
            res?.msg ||
            res?.errors?.[0]?.msg ||
            t("Please Wait or try again later!!"),
        );
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const SampleExcel = async (format = colorStoneSampleFormat) => {
    const GetloadingID = loading();
    try {
      const exportFormat =
        String(format).toLowerCase() === "csv" ? "csv" : "xlsx";
      const res = await _Api(
        { format: exportFormat },
        `api/v1/Inventory/colorStone/ColorStoneSamplexls`,
      );
      const url = res?.filexlsx || res?.data;
      if (res?.code === 200 && url) {
        const a = document.createElement("a");
        a.hidden = true;
        a.href = url;
        a.download = `ColorStone_Sample.${exportFormat}`;
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        a.remove();
        Updateloading(
          t,
          GetloadingID,
          res?.message || t("Sample template downloaded"),
        );
      } else {
        Updateloading(
          t,
          GetloadingID,
          res?.message || t("Could not download sample template"),
          "error",
        );
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(
        t,
        GetloadingID,
        t("Could not download sample template"),
        "error",
      );
    }
  };

  const printPayload = () => {
    const payload = buildPayload(skip);
    return { ...payload, status: payload.Status };
  };

  const getshareColorStoneSearch = async () => {
    setSocialurl(undefined);
    setShareloader(true);
    const modalEl = document.getElementById("socialModal");
    if (modalEl && window.bootstrap?.Modal) {
      window.bootstrap.Modal.getOrCreateInstance(modalEl).show();
    }
    try {
      const res = await _Api(
        printPayload(),
        `api/v1/Inventory/inventory/print/ColorStoneSearch`,
      );
      if (res.code === 200 && res?.link) {
        setSocialurl(res.link);
      } else {
        error(res?.message || t("Please Wait or try again later!!"));
      }
    } catch (err) {
      console.log(err, "err");
      error(t("Please Wait or try again later!!"));
    } finally {
      setShareloader(false);
    }
  };

  const getprintColorStoneSearch = async () => {
    const GetloadingID = loading();
    try {
      const res = await _Api(
        printPayload(),
        `api/v1/Inventory/inventory/print/ColorStoneSearch`,
      );
      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement("a");
          exportLinkElement.hidden = true;
          exportLinkElement.download = res?.name ? res?.name : "report.pdf";
          exportLinkElement.href = res?.link;
          exportLinkElement.text = "downloading...";
          exportLinkElement.setAttribute("target", "_blank");
          document.body.appendChild(exportLinkElement);
          exportLinkElement.click();
          exportLinkElement.remove();
          Updateloading(t, GetloadingID, t("download successfully"));
        }, 50);
        setSocialurl(res?.link);
      } else {
        Updateloading(
          t,
          GetloadingID,
          res?.message ? res?.message : res?.errors,
          "error",
        );
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, err, t("error"));
    }
  };

  const callexportrequest = async (format = colorStoneExportFormat) => {
    try {
      const res = await _Api(
        { type: "ColorStoneExport", format: format || "xlsx" },
        `api/v1/Inventory/colorStone/downloadColorStonexls`,
      );
      if (res.code === 200) {
        success(
          t(
            res?.message ||
              "Export started. Download will be available in Notifications.",
          ),
        );
      } else {
        error(res?.message || t("Please Wait or try again later!!"));
      }
    } catch (err) {
      error(t("Please Wait or try again later!!"));
      console.log(err, "err");
    }
  };

  const isStock = (item) => Number(item?.Status) === 1;

  const deleteColorStones = async () => {
    const ids = comparison.filter(isStock).map((c) => c._id);
    if (!ids.length) return;
    const loadingId = loading();
    try {
      const res = await _Api(
        { ids },
        `api/v1/Inventory/colorStone/deleteColorStone`,
      );
      if (res?.code === 200) {
        Updateloading(
          t,
          loadingId,
          t(res?.message || "Color stone deleted successfully"),
        );
        setComparison([]);
        if (ids.includes(detailId)) closeDetail();
        fetchList(skip);
      } else {
        Updateloading(
          t,
          loadingId,
          res?.message || res?.errors || t("Please Wait or try again later!!"),
          "error",
        );
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(
        t,
        loadingId,
        t("Please Wait or try again later!!"),
        "error",
      );
    }
  };

  const isDeallocatable = (item) => [2, 3].includes(Number(item?.Status));

  const selectionGroup = (item) =>
    isStock(item) ? "stock" : isDeallocatable(item) ? "deallocate" : "other";

  const deallocateColorStones = async (type, comment = "") => {
    const ids = comparison.filter(isDeallocatable).map((c) => c._id);
    if (!ids.length) return;
    const loadingId = loading();
    try {
      // const res = await _Api({ ids, type }, `api/v1/Inventory/colorStone/deallocation`);
      const res = await _Api(
        { ids, type, comment },
        `api/v1/Inventory/colorStone/deallocation`,
      );
      if (res?.code === 200) {
        Updateloading(
          t,
          loadingId,
          t(res?.message || "Color stone deallocated successfully"),
        );
        setComparison([]);
        if (ids.includes(detailId)) openDetail({ _id: detailId });
        fetchList(skip);
      } else {
        Updateloading(
          t,
          loadingId,
          res?.message || res?.errors || t("Please Wait or try again later!!"),
          "error",
        );
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(
        t,
        loadingId,
        t("Please Wait or try again later!!"),
        "error",
      );
    }
  };

  const isSelected = (item) => comparison.some((c) => c._id === item?._id);
  const hasStockSelected = comparison.some(isStock);
  const hasDeallocatableSelected = comparison.some(isDeallocatable);
  // const canSelect = (item) =>
  //   isSelected(item) || !comparison.length || isStock(item) === hasStockSelected;
  const canSelect = (item) =>
    isSelected(item) ||
    !comparison.length ||
    selectionGroup(item) === selectionGroup(comparison[0]);

  const toggleCompare = (item) => {
    // if (!isStock(item)) return;
    if (!canSelect(item)) return;
    setComparison((prev) =>
      prev.some((c) => c._id === item._id)
        ? prev.filter((c) => c._id !== item._id)
        : [...prev, item],
    );
  };

  const stockItemsOf = (list) => (list || []).filter(isStock);
  const allStockSelected = (list) => {
    const stock = stockItemsOf(list);
    return stock.length > 0 && stock.every(isSelected);
  };
  const canSelectAllStock = (list) =>
    stockItemsOf(list).length > 0 && (!comparison.length || hasStockSelected);

  const toggleSelectAllStock = (list) => {
    const stock = stockItemsOf(list);
    if (!stock.length) return;
    if (allStockSelected(list)) {
      const ids = new Set(stock.map((s) => s._id));
      setComparison((prev) => prev.filter((c) => !ids.has(c._id)));
      return;
    }
    if (!canSelectAllStock(list)) return;
    setComparison((prev) => {
      const ids = new Set(prev.map((c) => c._id));
      return [...prev, ...stock.filter((s) => !ids.has(s._id))];
    });
  };

  const shapeNameByLogo = useMemo(() => {
    const map = {};
    (filters?.Shape || []).forEach((s) => {
      if (s?.logo) map[s.logo] = s.name;
    });
    return map;
  }, [filters]);

  const shapeName = (item) =>
    item?.ShapeName || shapeNameByLogo[item?.Shape] || "";

  const visibleItems = useMemo(() => {
    const q = searchText.trim().toLowerCase();
    if (!q) return items || [];
    return (items || []).filter((item) =>
      [
        item?.Carat,
        item?.Colour,
        item?.Clarity,
        item?.Cut,
        item?.Certification,
        item?.Location,
        item?.Price,
        shapeNameByLogo[item?.Shape],
      ]
        .filter((v) => v !== undefined && v !== null)
        .some((v) => String(v).toLowerCase().includes(q)),
    );
  }, [items, searchText, shapeNameByLogo]);

  const dateButtonLabel =
    startdate && enddate
      ? `${formatRangeDate(startdate)} – ${formatRangeDate(enddate)}`
      : t("Show All");

  const presetLabel = OLD_DATE_PRESETS.find(
    ([value]) => value === datelable,
  )?.[1];
  // const dateOldLabel =
  //   !startdate || !enddate
  //     ? t('Show All')
  //     : datelable === 'Custom Range' || !presetLabel
  //       ? dateButtonLabel
  //       : t(presetLabel);
  const dateOldLabel =
    !startdate || !enddate || !presetLabel ? t("Show All") : t(presetLabel);

  const statCards = [
    {
      label: "Free Stock",
      value: stats.freeStock ?? totalresult,
      icon: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M32.3875 19.1562L24.0001 23.9987L15.6094 19.1484"
            stroke="#7CC7FA"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M24 24V33"
            stroke="#7CC7FA"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M23.0001 14.5765C23.6189 14.2193 24.3813 14.2193 25.0001 14.5765L31.6604 18.4218C32.2792 18.7791 32.6604 19.4394 32.6604 20.1539V27.8445C32.6604 28.559 32.2792 29.2193 31.6604 29.5766L25.0001 33.4218C24.3813 33.7791 23.6189 33.7791 23.0001 33.4218L16.3398 29.5766C15.721 29.2193 15.3398 28.559 15.3398 27.8445V20.1539C15.3398 19.4394 15.721 18.7791 16.3398 18.4218L23.0001 14.5765Z"
            stroke="#7CC7FA"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M20.5 16.5L28 21"
            stroke="#7CC7FA"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      tone: "blue",
    },
    {
      label: "Reserve",
      // value: stats.saleOrder ?? 0,
      value: stats.reserve ?? 0,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.5 15.0275C5.5 13.023 6.1235 11.3525 7.3705 10.0161C8.61751 8.67203 10.1728 8 12.0364 8C13.8445 8 15.3721 8.67971 16.6191 10.0391C17.873 11.3986 18.5 13.0614 18.5 15.0275C18.5 17.0321 17.8696 18.7256 16.6087 20.1081C15.3479 21.4906 13.8064 22.1818 11.9844 22.1818C10.1693 22.1818 8.63483 21.4906 7.3809 20.1081C6.12697 18.7256 5.5 17.0321 5.5 15.0275ZM7.3705 15.0506C7.3705 17.0244 7.7931 18.622 8.63829 19.8431C9.48348 21.0566 10.5919 21.6634 11.9636 21.6634C13.3492 21.6634 14.4715 21.0413 15.3305 19.7971C16.1965 18.5528 16.6295 17.0014 16.6295 15.1428C16.6295 13.1459 16.2069 11.5445 15.3617 10.3387C14.5165 9.12518 13.4219 8.51843 12.0779 8.51843C10.6508 8.51843 9.50773 9.11365 8.64868 10.3041C7.79656 11.4946 7.3705 13.0767 7.3705 15.0506Z"
            fill="#FE918F"
          />
          <path
            d="M11.9176 1.5L12.6852 6.81818H11.15L11.9176 1.5Z"
            fill="#FE918F"
          />
          <path
            d="M17.022 2.89531L15.1768 7.68466L13.331 6.8003L17.022 2.89531Z"
            fill="#FE918F"
          />
          <path
            d="M6.81395 2.89531L8.65909 7.68466L10.5049 6.8003L6.81395 2.89531Z"
            fill="#FE918F"
          />
        </svg>
      ),
      tone: "red",
    },
    {
      label: "Locations",
      value: stats.locations ?? 0,
      icon: <PlaceOutlinedIcon fontSize="medium" />,
      tone: "teal",
    },
    {
      label: "Reorder Quantity",
      value: stats.reorderQuantity ?? 0,
      icon: <RefreshIcon fontSize="medium" />,
      tone: "blue",
    },
  ];

  const renderChips = (key, list, getValue, getLabel) => (
    <div className="ds-chips">
      {(list || []).map((option, index) => {
        const value = getValue(option);
        const isActive = sel[key].includes(value);
        return (
          <button
            key={`${key}-${value}-${index}`}
            type="button"
            className={`ds-chip ${isActive ? "active" : ""}`}
            onClick={() => toggleSelection(key, value)}
          >
            {getLabel(option)}
          </button>
        );
      })}
    </div>
  );

  const renderRange = (key, label, value, bounds, unit, step = 1) => (
    <div className="ds-filter-block">
      <h6 className="ds-filter-title">{t(label)}</h6>
      <div className="ds-range">
        <div className="ds-range-inputs">
          {[0, 1].map((i) => (
            <label className="ds-range-input" key={i}>
              <input
                type="number"
                step={step}
                value={value[i]}
                onChange={(e) => {
                  const next = [...value];
                  next[i] = e.target.value;
                  rangeSetters[key](next);
                }}
                onBlur={() => commitRange(key, value)}
                onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
              />
              <span>{unit}</span>
            </label>
          ))}
        </div>
        <Slider
          range
          min={bounds[0]}
          max={bounds[1]}
          step={step}
          value={value.map(Number)}
          onChange={rangeSetters[key]}
          onAfterChange={(v) => fetchList(0, { [key]: v })}
        />
      </div>
    </div>
  );

  const renderStatusBadge = (item, variant = "") => {
    const meta = STATUS_META[item?.Status];
    if (!meta) return null;
    const tooltip = item?.reserveDate
      ? `${item?.customer || ""} ${formatDate(item?.reserveDate)}`.trim()
      : t(meta.label);
    return (
      <span
        className={`ds-status ${meta.className} ${variant}`.trim()}
        title={tooltip}
      >
        {t(meta.label)}
      </span>
    );
  };

  const STATUS_DOT_CLASS = {
    1: "status-yellow light-blue",
    2: "status-yellow light-yellow-bg",
    3: "status-yellow bg-danger",
    4: "status-gray-tab light-gray-bg",
  };

  // const statusCustomerOf = (item) => {
  //   const c = item?.customer ?? item?.Customer ?? item?.customer_name ?? item?.customerName;
  //   if (c && typeof c === 'object') return c.name || c.Name || c.customer_name || c.fullName || '';
  //   return c || '';
  // };
  //
  // const statusDateOf = (item) =>
  //   item?.reserveDate || item?.soldDate || item?.SoldDate || item?.transitDate || item?.orderDate || '';
  const statusCustomerOf = (item) => {
    const c =
      item?.customer ||
      item?.Customer ||
      item?.customer_name ||
      item?.Customer_name ||
      item?.customerName ||
      item?.CustomerName ||
      item?.reserveBy ||
      item?.reservedBy;
    if (c && typeof c === "object")
      return c.name || c.Name || c.customer_name || c.fullName || "";
    return c || "";
  };

  const statusDateOf = (item) =>
    item?.reserveDate ||
    item?.ReserveDate ||
    item?.reserve_date ||
    item?.soldDate ||
    item?.SoldDate ||
    item?.sold_date ||
    item?.orderDate ||
    item?.order_date ||
    item?.deliveryDate ||
    item?.delivery_date ||
    item?.transitDate ||
    "";

  const renderStatusDot = (item) => {
    const status = Number(item?.Status);
    const dotClass = STATUS_DOT_CLASS[status] || "status-color bg-main-green";
    let tooltip = null;
    if (item?.reserveDate) {
      tooltip = (
        <>
          {item?.customer}
          <br />
          {formatDate(item?.reserveDate)}
        </>
      );
    } else if (status === 1) {
      tooltip = t("Stock");
    }
    //  else if (status === 3) {
    //   tooltip = t('Custom Order');
    // }
    //  else if (status === 4) {
    //   tooltip = t('Transit');
    // }
    return (
      <div className={`${dotClass} tooltip-area-up ds-status-dot`}>
        {tooltip && <span className="tooltip-area-up-text">{tooltip}</span>}
      </div>
    );
  };

  // eslint-disable-next-line no-unused-vars
  const renderStatusDotOld = (item) => {
    const status = Number(item?.Status);
    const dotClass = STATUS_DOT_CLASS[status] || "status-color bg-main-green";
    let tooltip = null;
    if (item?.reserveDate) {
      tooltip = (
        <>
          {item?.customer}
          <br />
          {formatDate(item?.reserveDate)}
        </>
      );
    } else if (status === 1) {
      tooltip = t("Stock");
    }
    //  else if (status === 3) {
    //   tooltip = t('Custom Order');
    // }
    //  else if (status === 4) {
    //   tooltip = t('Transit');
    // }
    return (
      <div className={`${dotClass} tooltip-area-up ds-status-dot`}>
        {tooltip && <span className="tooltip-area-up-text">{tooltip}</span>}
      </div>
    );
  };

  const isDetailDisabled = (item) => [3, 4].includes(item?.Status);

  const openDetail = async (item) => {
    if (!item?._id || isDetailDisabled(item)) return;
    const requestId = ++detailRequestRef.current;
    setDetailId(item._id);
    setDetails(null);
    setDetailLoading(true);
    try {
      const res = await _Api(
        { id: item._id },
        `api/v1/Inventory/colorStone/getDetails`,
      );
      if (requestId !== detailRequestRef.current) return;
      if (res?.code === 200) setDetails(res.data || null);
    } catch (err) {
      console.log(err, "err");
    } finally {
      if (requestId === detailRequestRef.current) setDetailLoading(false);
    }
  };

  const location = useLocation();
  const navigate = useNavigate();
  const openColorStoneId = location.state?.openColorStoneId;

  useEffect(() => {
    if (!openColorStoneId) return;
    openDetail({ _id: openColorStoneId });
    navigate(location.pathname, { replace: true, state: null });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openColorStoneId]);

  const closeDetail = () => {
    detailRequestRef.current += 1;
    setDetailId(null);
    setDetails(null);
    setDetailLoading(false);
  };

  const removeReserve = async () => {
    if (!detailId) return;
    try {
      const res = await _Api(
        { id: detailId },
        `api/v1/Inventory/colorStone/removeReserve`,
      );
      if (res?.code === 200) {
        setDetails((d) =>
          d ? { ...d, Status: 1, reserveDate: "", customer: "" } : d,
        );
        setItems((list) =>
          list.map((i) => (i?._id === detailId ? { ...i, Status: 1 } : i)),
        );
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const renderCard = (item) => {
    const isCompared = comparison.some((c) => c._id === item?._id);
    const name = shapeName(item);
    const title = `${item?.Carat ?? ""} ${t("Carats")} ${name} -${item?.Colour ?? ""} / ${item?.Clarity ?? ""}`;
    const subtitle = [
      `${item?.Carat ?? ""} ${t("Carats")}`,
      `${item?.Colour ?? ""}${t("Colour")}`,
      `${item?.Clarity ?? ""} ${t("Clarity")}${name}`,
      item?.Cut,
    ]
      .filter(Boolean)
      .join(", ");
    return (
      // <div className={`ds-card ${isDetailDisabled(item) ? 'is-disabled' : ''}`} key={item?._id}>
      <div
        className={`ds-card ${isDetailDisabled(item) ? "is-disabled" : ""} ${canSelect(item) ? "" : "is-select-locked"}`}
        key={item?._id}
      >
        <label className="ds-card-check" onClick={(e) => e.stopPropagation()}>
          <input
            type="checkbox"
            checked={isCompared}
            // disabled={!isStock(item)}
            disabled={!canSelect(item)}
            onChange={() => toggleCompare(item)}
          />
          <span />
        </label>
        <div
          className="ds-card-link"
          role="button"
          tabIndex={0}
          onClick={() => openDetail(item)}
          onKeyDown={(e) => e.key === "Enter" && openDetail(item)}
        >
          <div className="ds-card-img">
            {/* <img
              src={item?.Shape ? item?.Shape : base_assets + 'images/icon/camera_profile.png'}
              alt={name}
            /> */}
            {previewMediaOf(item) ? (
              renderPreviewMedia(previewMediaOf(item), name)
            ) : (
              <img
                src={
                  item?.Shape
                    ? item?.Shape
                    : base_assets + "images/icon/camera_profile.png"
                }
                alt={name}
              />
            )}
          </div>
          <div className="ds-card-body">
            <div className="ds-card-head">
              <p className="ds-card-title">{title}</p>
              {/* {renderStatusBadge(item, 'ds-status-grid')} */}
              {/* {renderStatusDot(item)} */}
            </div>
            <p className="ds-card-sub">{subtitle}</p>
            <p className="ds-card-cert">{shownCert(item).number}</p>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <p className="ds-card-price">{item?.Price || "0.00"}</p>
              <div style={{ margin: "7.5px 0px 0px" }}>
                {renderStatusDot(item)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const certificatesOf = (item) => {
    const raw = item?.Certificates || item?.certificates;
    const list = (Array.isArray(raw) ? raw : [])
      .filter(Boolean)
      .map((c) => ({
        lab: c?.GradedBy || c?.gradedBy || c?.lab || "",
        number: c?.Certification || c?.certification || c?.number || "",
        url: c?.CertificationUrl || c?.certificationUrl || c?.url || "",
        image: c?.image || c?.Image || "",
      }))
      .filter((c) => c.lab || c.number || c.url);
    if (list.length) return list;
    if (item?.Certification || item?.GradedBy || item?.CertificationUrl) {
      return [
        {
          lab: item?.GradedBy || "",
          number: item?.Certification || "",
          url: item?.CertificationUrl || "",
          image:
            item?.CertificationImage ||
            item?.CertificateImage ||
            item?.certificate_image ||
            "",
        },
      ];
    }
    return [];
  };

  const shownCert = (item) => {
    const certs = certificatesOf(item);
    return (
      certs[certChoice[item?._id] || 0] ||
      certs[0] || { lab: "", number: "", url: "", image: "" }
    );
  };

  const tableColumns = [
    {
      key: "status",
      label: "Status",
      className: "ds-table-status",
      cell: (item) => renderStatusDot(item),
    },
    {
      key: "img",
      label: "Img",
      className: "ds-table-shape",
      cell: (item) => {
        const url = previewMediaOf(item);
        return url ? (
          renderPreviewMedia(url, item?.StoneName || item?.ProductName || "")
        ) : (
          <img src={base_assets + "images/icon/camera_profile.png"} alt="" />
        );
      },
    },
    {
      key: "stone",
      label: "Stone",
      className: "ds-table-stone",
      cell: (item) => (
        <span className="ds-stone-cell" style={{ display: "flex" }}>
          <span className="ds-ellipsis">
            {item?.StoneName || item?.stoneName || ""}
          </span>
          {!isDetailDisabled(item) && (
            <button
              type="button"
              className="ds-stone-edit-btn"
              aria-label={t("Information")}
              title={t("Information")}
              onClick={(e) => {
                e.stopPropagation();
                openDetail(item);
              }}
              style={{ marginLeft: "auto" }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.2984 4.70163C18.5295 3.93279 17.283 3.93279 16.5141 4.70163L15.6463 5.5695L18.4305 8.35373L19.2984 7.48587C20.0672 6.71702 20.0672 5.47048 19.2984 4.70163Z"
                  fill="#BCBCBC"
                />
                <path
                  d="M17.635 9.14923L14.8508 6.365L5.73766 15.4781C5.27507 15.9407 4.93502 16.5113 4.74826 17.1383L4.14842 19.1519C4.08946 19.3499 4.14372 19.5642 4.28977 19.7102C4.43581 19.8563 4.65015 19.9106 4.8481 19.8516L6.86177 19.2517C7.48875 19.065 8.05931 18.7249 8.5219 18.2623L17.635 9.14923Z"
                  fill="#BCBCBC"
                />
              </svg>
            </button>
          )}
        </span>
      ),
    },
    {
      key: "category",
      label: "Category",
      className: "ds-table-category",
      cell: (item) => (
        <span className="ds-ellipsis">{categoryText(item) || ""}</span>
      ),
    },
    {
      key: "size",
      label: "Size",
      cell: (item) => item?.Size ?? item?.size ?? "",
    },
    {
      key: "shape",
      label: "Shape",
      className: "ds-table-shape",
      cell: (item) => (
        <img
          src={
            item?.Shape
              ? item?.Shape
              : base_assets + "images/icon/camera_profile.png"
          }
          alt=""
        />
      ),
    },
    {
      key: "weight",
      label: "Weight",
      className: "ds-link",
      cell: (item) =>
        isDetailDisabled(item) ? (
          (item?.Carat ?? item?.Weight ?? "")
        ) : (
          <button
            type="button"
            className="ds-carat-link"
            onClick={(e) => {
              e.stopPropagation();
              openDetail(item);
            }}
          >
            {item?.Carat ?? item?.Weight ?? ""}
          </button>
        ),
    },
    { key: "colour", label: "Colour", cell: (item) => item?.Colour ?? "" },
    { key: "clarity", label: "Clarity", cell: (item) => item?.Clarity ?? "" },
    { key: "cut", label: "Cut", cell: (item) => item?.Cut ?? "" },
    { key: "origin", label: "Origin", cell: (item) => item?.Origin ?? "" },
    {
      key: "treatment",
      label: "Treatment",
      cell: (item) => item?.Treatment ?? "",
    },
    {
      key: "grade",
      label: "Grade",
      cell: (item) => shownCert(item).lab || item?.GradedBy || "",
    },
    {
      key: "certification",
      label: "Certification",
      cell: (item) => {
        const certs = certificatesOf(item);
        const cert = shownCert(item);
        const open = certMenu?.id === item?._id;
        return (
          <span className="ds-table-cert">
            {certs.length > 1 ? (
              <button
                type="button"
                className="ds-link ds-cert-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  const rect = e.currentTarget.getBoundingClientRect();
                  setCertMenu(
                    open
                      ? null
                      : { id: item._id, top: rect.bottom + 4, left: rect.left },
                  );
                }}
              >
                {cert.number}
              </button>
            ) : (
              <span className="ds-link">{cert.number}</span>
            )}
            {cert.url && (
              <a
                className="ds-link"
                target="_blank"
                rel="noreferrer"
                href={cert.url}
                aria-label={t("Certificate link")}
                onClick={(e) => e.stopPropagation()}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.3713 7.62868C9.19975 6.45711 7.30025 6.45711 6.12868 7.62868L3.12868 10.6287C1.95711 11.8003 1.95711 13.6997 3.12868 14.8713C4.30025 16.0429 6.19975 16.0429 7.37132 14.8713L8.19749 14.0451M7.62868 10.3713C8.80025 11.5429 10.6997 11.5429 11.8713 10.3713L14.8713 7.37132C16.0429 6.19975 16.0429 4.30025 14.8713 3.12868C13.6997 1.95711 11.8003 1.95711 10.6287 3.12868L9.80397 3.95339"
                    stroke="#606060"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            )}
            {open && (
              <div
                className="ds-cert-pop"
                style={{ top: certMenu.top, left: certMenu.left }}
              >
                {certs.map((c, index) => (
                  <button
                    key={`${c.lab}-${c.number}-${index}`}
                    type="button"
                    className={
                      index === (certChoice[item._id] || 0) ? "active" : ""
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      setCertChoice((prev) => ({ ...prev, [item._id]: index }));
                      setCertMenu(null);
                    }}
                  >
                    {c.lab && <span>{c.lab}</span>}
                    <span>{c.number}</span>
                  </button>
                ))}
              </div>
            )}
          </span>
        );
      },
    },
    { key: "stockId", label: "Stock Id", cell: (item) => item?.StockID ?? "" },
    {
      key: "price",
      label: "Price",
      className: "text-end",
      cell: (item) => formatPrice(item?.Price),
    },
    {
      key: "location",
      label: "Location",
      cell: (item) => item?.Location ?? "",
    },
  ];

  const columnByKey = Object.fromEntries(
    tableColumns.map((col) => [col.key, col]),
  );
  // const visibleColumns = columnPrefs
  //   .filter((pref) => pref.visible && columnByKey[pref.key])
  //   .map((pref) => columnByKey[pref.key]);
  // const visibleColumns = columnPrefs
  //   .filter((pref) => (pref.visible || isFixedColumn(pref.key)) && columnByKey[pref.key])
  //   .map((pref) => columnByKey[pref.key]);
  // const fixedColumnPrefs = columnPrefs.filter((pref) => isFixedColumn(pref.key));
  const fixedColumnPrefs = FIXED_COLUMN_KEYS.map((key) => ({
    key,
    visible: true,
  }));
  const activeColumnPrefs = columnPrefs.filter(
    (pref) => !isFixedColumn(pref.key),
  );
  const visibleColumns = [
    ...fixedColumnPrefs,
    ...activeColumnPrefs.filter((pref) => pref.visible),
  ]
    .filter((pref) => columnByKey[pref.key])
    .map((pref) => columnByKey[pref.key]);

  // const toggleColumn = (key) =>
  //   setColumnPrefs((prev) => {
  //     const visibleCount = prev.filter((p) => p.visible).length;
  //     return prev.map((p) =>
  //       p.key === key && !(p.visible && visibleCount === 1) ? { ...p, visible: !p.visible } : p,
  //     );
  //   });
  const toggleColumn = (key) => {
    if (isFixedColumn(key)) return;
    setColumnPrefs((prev) =>
      prev.map((p) => (p.key === key ? { ...p, visible: !p.visible } : p)),
    );
  };

  const moveColumn = (fromKey, toKey) => {
    if (!fromKey || fromKey === toKey) return;
    setColumnPrefs((prev) => {
      const from = prev.findIndex((p) => p.key === fromKey);
      const to = prev.findIndex((p) => p.key === toKey);
      if (from === -1 || to === -1) return prev;
      const next = [...prev];
      const [moved] = next.splice(from, 1);
      next.splice(to, 0, moved);
      return next;
    });
  };

  const renderTableRows = (list, isComparison) =>
    list.map((item, key) => (
      <tr
        key={item?._id || key}
        // className={`ds-table-row ${isDetailDisabled(item) ? 'is-disabled' : ''}`}
        className={`ds-table-row ${isDetailDisabled(item) ? "is-disabled" : ""} ${canSelect(item) ? "" : "is-select-locked"}`}
        // onClick={() => openDetail(item)}
      >
        <td onClick={(e) => e.stopPropagation()}>
          {isComparison ? (
            <button
              type="button"
              className="ds-icon-btn"
              onClick={() => toggleCompare(item)}
              aria-label={t("Remove")}
            >
              <DeleteOutlineIcon fontSize="small" />
            </button>
          ) : (
            <label className="ds-card-check static">
              <input
                type="checkbox"
                checked={comparison.some((c) => c._id === item?._id)}
                // disabled={!isStock(item)}
                disabled={!canSelect(item)}
                onChange={() => toggleCompare(item)}
              />
              <span />
            </label>
          )}
        </td>
        <td>{isComparison ? key + 1 : skip + key + 1}</td>
        {visibleColumns.map((col) => (
          <td key={col.key} className={col.className}>
            {col.cell(item)}
          </td>
        ))}
        <td />
      </tr>
    ));

  const renderTable = (list, isComparison = false) => (
    <div className="ds-table-outer">
      <div className="ds-table-wrap">
        <table className="ds-table">
          <thead>
            <tr>
              {/* <th /> */}
              <th>
                {!isComparison && (
                  <label
                    className="ds-card-check static"
                    title={t("Select all stock diamonds")}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <input
                      type="checkbox"
                      checked={allStockSelected(list)}
                      disabled={
                        !allStockSelected(list) && !canSelectAllStock(list)
                      }
                      onChange={() => toggleSelectAllStock(list)}
                    />
                    <span />
                  </label>
                )}
              </th>
              <th>#</th>
              {visibleColumns.map((col) => (
                <th
                  key={col.key}
                  className={
                    col.className === "text-end" ? "text-end" : undefined
                  }
                  style={col.style}
                >
                  {t(col.label)}
                </th>
              ))}
              <th
                className="text-center"
                style={{ cursor: "pointer", padding: "10px 2px" }}
              >
                <button
                  type="button"
                  ref={columnsBtnRef}
                  className={`ds-icon-btn plain ds-columns-btn ${columnsMenuOpen ? "active" : ""}`}
                  onClick={() => setColumnsMenuOpen((o) => !o)}
                  aria-label={t("Show or hide properties")}
                  aria-expanded={columnsMenuOpen}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.168 11.668H5.83464C4.91416 11.668 4.16797 12.4142 4.16797 13.3346V15.0013C4.16797 15.9218 4.91416 16.668 5.83464 16.668H14.168C15.0884 16.668 15.8346 15.9218 15.8346 15.0013V13.3346C15.8346 12.4142 15.0884 11.668 14.168 11.668Z"
                      stroke="#606060"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.4987 3.33203H7.4987C6.57822 3.33203 5.83203 4.07822 5.83203 4.9987V6.66536C5.83203 7.58584 6.57822 8.33203 7.4987 8.33203H12.4987C13.4192 8.33203 14.1654 7.58584 14.1654 6.66536V4.9987C14.1654 4.07822 13.4192 3.33203 12.4987 3.33203Z"
                      stroke="#606060"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.3346 5.83203H14.168"
                      stroke="#606060"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.83203 5.83203H0.832031"
                      stroke="#606060"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.332 14.168H15.832"
                      stroke="#606060"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4.16797 14.168H1.66797"
                      stroke="#606060"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            {list.length > 0 && (
              <tr className="ds-table-total">
                <td colSpan={2}>{t("Total")}</td>
                {visibleColumns.map((col) => (
                  <td
                    key={col.key}
                    className={col.key === "price" ? "text-end" : undefined}
                  >
                    {col.key === "price" ? formatPrice(sumPrices(list)) : ""}
                  </td>
                ))}
                <td />
              </tr>
            )}
            {renderTableRows(list, isComparison)}
          </tbody>
        </table>
      </div>
      {columnsMenuOpen && (
        <div className="ds-columns-menu" ref={columnsMenuRef}>
          {/* <p className="ds-columns-title">{t('Fixed columns')}</p>
        <label className="ds-columns-item is-fixed">
          <span className="ds-columns-check">
            <input type="checkbox" checked disabled readOnly />
            <span />
          </span>
          {t('Check box')}
        </label> */}
          {/* {fixedColumnPrefs.map((pref) => (
          <label key={pref.key} className="ds-columns-item is-fixed">
            <span className="ds-columns-check">
              <input type="checkbox" checked disabled readOnly />
              <span />
            </span>
            {t(columnByKey[pref.key]?.label)}
          </label>
        ))}
        <hr /> */}
          <p className="ds-columns-title">{t("Active columns")}</p>
          <ul className="ds-columns-list">
            {/* {columnPrefs.map((pref) => ( */}
            {activeColumnPrefs.map((pref) => (
              <li
                key={pref.key}
                className={`ds-columns-item ${draggingColumn === pref.key ? "is-dragging" : ""}`}
                draggable
                onDragStart={(e) => {
                  setDraggingColumn(pref.key);
                  e.dataTransfer.effectAllowed = "move";
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                  moveColumn(draggingColumn, pref.key);
                }}
                onDragEnd={() => setDraggingColumn(null)}
              >
                <label className="ds-columns-check">
                  <input
                    type="checkbox"
                    checked={pref.visible}
                    onChange={() => toggleColumn(pref.key)}
                  />
                  <span />
                </label>
                <span
                  className="ds-columns-label"
                  onClick={() => toggleColumn(pref.key)}
                >
                  {t(columnByKey[pref.key]?.label)}
                </span>
                <DragIndicatorIcon
                  className="ds-columns-drag"
                  fontSize="small"
                />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );

  const priceBounds = toRange(filters?.Price);
  const caratBounds = toRange(filters?.Carat);

  const dateFilterEl = (
    <div className="ds-date ds-date-old" ref={dateMenuRef}>
      <button
        type="button"
        className={`ds-date-old-btn ${dateMenuOpen ? "open" : ""}`}
        onClick={() => {
          setCustomRangeOpen(false);
          toggleDateMenu();
        }}
      >
        {dateOldLabel}
      </button>
      {dateMenuOpen && (
        <div className="ds-date-old-menu">
          <ul className="ds-date-old-list">
            {OLD_DATE_PRESETS.map(([value, label]) => (
              <li
                key={value}
                className={
                  (
                    value === "Custom Range"
                      ? customRangeOpen || datelable === value
                      : datelable === value
                  )
                    ? "active"
                    : ""
                }
                onClick={() => {
                  if (value === "Custom Range") {
                    syncDraft(startdate, enddate);
                    setCustomRangeOpen(true);
                    setDateMenuOpen(false);
                  } else {
                    setCustomRangeOpen(false);
                    changeDates(value);
                  }
                }}
              >
                {t(label)}
              </li>
            ))}
          </ul>
          {/* {customRangeOpen && (
            <div className="ds-date-old-calendar">
              <DatePicker
                inline
                selectsRange
                monthsShown={2}
                startDate={draftStart}
                endDate={draftEnd}
                openToDate={draftStart || new Date()}
                onChange={([start, end]) => {
                  syncDraft(start, end);
                  if (start && end) {
                    applyCustomRange(start, end);
                    setCustomRangeOpen(false);
                  }
                }}
              />
            </div>
          )} */}
        </div>
      )}
      {customRangeOpen && (
        <div className="ds-date-old-calendar">
          <DatePicker
            inline
            selectsRange
            monthsShown={2}
            startDate={draftStart}
            endDate={draftEnd}
            openToDate={draftStart || new Date()}
            formatWeekDay={(name) => name.slice(0, 2)}
            onChange={([start, end]) => {
              syncDraft(start, end);
              if (start && end) {
                applyCustomRange(start, end);
                setCustomRangeOpen(false);
              }
            }}
            renderCustomHeader={({
              monthDate,
              customHeaderCount,
              decreaseMonth,
              increaseMonth,
            }) => (
              <div className="ds-date-old-cal-header">
                <button
                  type="button"
                  aria-label={t("Previous month")}
                  onClick={decreaseMonth}
                  style={{
                    visibility: customHeaderCount === 0 ? "visible" : "hidden",
                  }}
                >
                  <ChevronLeftIcon fontSize="small" />
                </button>
                <span>
                  {monthDate.toLocaleDateString("en-US", {
                    month: "long",
                    year: "numeric",
                  })}
                </span>
                <button
                  type="button"
                  aria-label={t("Next month")}
                  onClick={increaseMonth}
                  style={{
                    visibility: customHeaderCount === 1 ? "visible" : "hidden",
                  }}
                >
                  <ChevronRightIcon fontSize="small" />
                </button>
              </div>
            )}
          />
        </div>
      )}
    </div>
  );

  /* const dateFilterElNew = (
    <div className="ds-date" ref={dateMenuRef}>
      <button type="button" className="ds-date-btn" onClick={toggleDateMenu}>
        <CalendarMonthOutlinedIcon fontSize="small" />
        <span className="ds-date-container">{dateButtonLabel}</span>
        <KeyboardArrowDownIcon fontSize="small" />
      </button>
      {dateMenuOpen && (
        <div className="ds-date-menu">
          <div className="ds-date-inputs">
            {[
              ['start', startText, setStartText],
              ['end', endText, setEndText],
            ].map(([which, text, setText]) => (
              <label className="ds-date-input" key={which}>
                <input
                  type="text"
                  value={text}
                  placeholder="dd/mm/yyyy"
                  onChange={(e) => setText(e.target.value)}
                  onBlur={() => commitTypedDate(which)}
                  onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.blur()}
                />
                <CalendarMonthOutlinedIcon fontSize="small" />
              </label>
            ))}
          </div>
          <div className="ds-date-body">
            <ul className="ds-date-presets">
              {DATE_PRESETS.map(([value, label]) => (
                <li
                  key={value}
                  className={datelable === value ? 'active' : ''}
                  onClick={() => changeDates(value)}
                >
                  {t(label)}
                </li>
              ))}
            </ul>
            <div className="ds-date-calendar">
              <DatePicker
                inline
                selectsRange
                fixedHeight
                startDate={draftStart}
                endDate={draftEnd}
                openToDate={draftStart || new Date()}
                formatWeekDay={(name) => name.slice(0, 3)}
                onChange={([start, end]) => {
                  syncDraft(start, end);
                  if (start && end) applyCustomRange(start, end);
                }}
                renderCustomHeader={({ date, changeYear, decreaseMonth, increaseMonth }) => (
                  <div className="ds-cal-header">
                    <button type="button" onClick={decreaseMonth} aria-label={t('Previous month')}>
                      <ChevronLeftIcon fontSize="small" />
                    </button>
                    <span className="ds-cal-month">
                      {date.toLocaleDateString('en-GB', { month: 'long' })}
                    </span>
                    <span className="ds-cal-year">
                      {date.getFullYear()}
                      <span className="ds-cal-year-spin">
                        <button
                          type="button"
                          onClick={() => changeYear(date.getFullYear() + 1)}
                          aria-label={t('Next year')}
                        >
                          <KeyboardArrowUpIcon fontSize="inherit" />
                        </button>
                        <button
                          type="button"
                          onClick={() => changeYear(date.getFullYear() - 1)}
                          aria-label={t('Previous year')}
                        >
                          <KeyboardArrowDownIcon fontSize="inherit" />
                        </button>
                      </span>
                    </span>
                    <button type="button" onClick={increaseMonth} aria-label={t('Next month')}>
                      <ChevronRightIcon fontSize="small" />
                    </button>
                  </div>
                )}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  ); */

  const selectionActionsEl = (
    <>
      {hasStockSelected && (
        <button
          type="button"
          className="ds-delete-btn"
          title={t("Delete")}
          aria-label={t("Delete")}
          data-bs-toggle="modal"
          data-bs-target="#delete-listedModal"
          onClick={() => setConfirmAction("delete")}
        >
          {/* <DeleteOutlineIcon fontSize="small" /> */}
          <img src={base_assets + "images/admin/icons/Delete.png"} alt="" />
        </button>
      )}
      {hasDeallocatableSelected && (
        <button
          type="button"
          className="ds-delete-btn"
          title={t("Deallocate")}
          aria-label={t("Deallocate")}
          data-bs-toggle="modal"
          data-bs-target="#deallcocat-modal"
        >
          <img src={base_assets + "images/admin/icons/Delete.png"} alt="" />
        </button>
      )}
    </>
  );

  const searchEl = (
    <label className="ds-search">
      <SearchOutlinedIcon fontSize="small" />
      <input
        type="text"
        value={searchText}
        placeholder={t("Search here...")}
        onChange={(e) => setSearchText(e.target.value)}
      />
    </label>
  );

  const detailCert = details
    ? shownCert(
        Array.isArray(details.Certificates) && details.Certificates.length
          ? { ...details, _id: detailId }
          : {
              ...(items.find((i) => i?._id === detailId) || details),
              _id: detailId,
            },
      )
    : { lab: "", number: "", url: "", image: "" };

  const detailRows = details
    ? [
        // ['Category', details.Category_name],
        ["Category", categoryText(details)],
        ["Shape", details.Shape],
        ["Weight", details.Carat],
        ["Color", details.Colour],
        ["Clarity", details.Clarity],
        ["Cut", details.Cut],
        ["Origin", details.Origin],
        ["Treatment", details.Treatment],
        // ['Certification', [details.GradedBy, details.Certification].filter(Boolean).join('    ')],
        [
          "Certification",
          [detailCert.lab, detailCert.number].filter(Boolean).join("    "),
        ],
        ["Location", details.Location],
      ]
    : [];

  const detailTitle = details
    ? `${details.Carat ?? ""} ${t("Carats")} ${details.Shape ?? ""} -${details.Colour ?? ""} / ${details.Clarity ?? ""}`
    : "";

  const detailDescription = details
    ? details.Description ||
      [
        `${details.Carat ?? ""} ${t("Carats")}`,
        `${details.Colour ?? ""}${t("Colour")}`,
        `${details.Clarity ?? ""} ${t("Clarity")}${details.Shape ?? ""}`,
        details.Cut ? `${details.Cut} ${t("Cut")}` : "",
      ]
        .filter(Boolean)
        .join(", ")
    : "";

  // const detailImage =
  //   details?.image?.[0] ||
  //   items.find((i) => i?._id === detailId)?.Shape ||
  //   base_assets + 'images/icon/camera_profile.png';
  // const imageUrl = (img) => (typeof img === 'string' ? img : img?.url || img?.image || img?.path || '');
  // const detailImages = (Array.isArray(details?.image) ? details.image : [details?.image])
  //   .map(imageUrl)
  //   .filter(Boolean);
  // const detailImage =
  //   imageUrl(details?.DefaultImage) ||
  //   imageUrl(details?.defaultImage) ||
  //   detailImages[Number(details?.DefaultImageIndex) || 0] ||
  //   detailImages[0] ||
  //   (Array.isArray(details?.video) ? details.video : [])
  //     .map(imageUrl)
  //     .find((url) => /\.gif(\?|$)/i.test(url)) ||
  //   items.find((i) => i?._id === detailId)?.Shape ||
  //   base_assets + 'images/icon/camera_profile.png';
  const detailImage =
    previewMediaOf(details) ||
    items.find((i) => i?._id === detailId)?.Shape ||
    base_assets + "images/icon/camera_profile.png";

  // const certificateImage =
  //   details?.Certificates?.find((c) => c?.image)?.image ||
  //   details?.CertificationImage ||
  //   details?.CertificateImage ||
  //   details?.certificate_image ||
  //   '';
  const certificateImage =
    detailCert.image ||
    details?.Certificates?.find((c) => c?.image)?.image ||
    details?.CertificationImage ||
    details?.CertificateImage ||
    details?.certificate_image ||
    "";

  const renderDetailView = () => (
    <div className="ds-detail-layout">
      <aside className="ds-detail-list">
        {/* <div className="ds-diamonds-list-title" style={{ padding: '0px 16px' }}>{t('Color Stones List')}</div> */}

        <div className="ds-detail-list-bar">
          <span className="ds-results-count">
            {t("Result")}: {totalresult} {t("row(s)")}
          </span>
          <button
            type="button"
            className="ds-icon-btn plain"
            onClick={() => {
              closeDetail();
              setShowMoreFilters(true);
            }}
          >
            <FilterListIcon fontSize="small" />
          </button>
          {selectionActionsEl}
          {dateFilterEl}
          {searchEl}
        </div>
        <div className="ds-detail-list-scroll">
          {visibleItems.map((item, key) => (
            <div
              key={item?._id || key}
              role="button"
              tabIndex={0}
              // className={`ds-detail-row ${item?._id === detailId ? 'active' : ''} ${isDetailDisabled(item) ? 'is-disabled' : ''}`}
              className={`ds-detail-row ${item?._id === detailId ? "active" : ""} ${isDetailDisabled(item) ? "is-disabled" : ""} ${canSelect(item) ? "" : "is-select-locked"}`}
              onClick={() => openDetail(item)}
              onKeyDown={(e) => e.key === "Enter" && openDetail(item)}
            >
              <label
                className="ds-card-check static"
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  checked={comparison.some((c) => c._id === item?._id)}
                  // disabled={!isStock(item)}
                  disabled={!canSelect(item)}
                  onChange={() => toggleCompare(item)}
                />
                <span />
              </label>
              <span className="ds-detail-row-no">{skip + key + 1}</span>
              <img
                className="ds-detail-row-shape"
                src={
                  item?.Shape
                    ? item?.Shape
                    : base_assets + "images/icon/camera_profile.png"
                }
                alt=""
              />
              <span className="ds-detail-row-carat">{item?.Carat ?? ""}</span>
              <span className="ds-detail-row-lab">{shownCert(item).lab}</span>
              <span className="ds-detail-row-cert">
                {/* {item?.Certification || ''} */}
                {shownCert(item).number}
                {/* {item?.CertificationUrl && item?._id === detailId && ( */}
                {/* {item?.CertificationUrl &&  ( */}
                {shownCert(item).url && (
                  <a
                    href={shownCert(item).url}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    aria-label={t("Certificate link")}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.3713 7.62868C9.19975 6.45711 7.30025 6.45711 6.12868 7.62868L3.12868 10.6287C1.95711 11.8003 1.95711 13.6997 3.12868 14.8713C4.30025 16.0429 6.19975 16.0429 7.37132 14.8713L8.19749 14.0451M7.62868 10.3713C8.80025 11.5429 10.6997 11.5429 11.8713 10.3713L14.8713 7.37132C16.0429 6.19975 16.0429 4.30025 14.8713 3.12868C13.6997 1.95711 11.8003 1.95711 10.6287 3.12868L9.80397 3.95339"
                        stroke="#606060"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                )}
              </span>
              <span className="ds-detail-row-location">
                {item?.Location ?? ""}
              </span>
              {/* <span className="ds-detail-row-status">{renderStatusBadge(item)}</span> */}
              <span className="ds-detail-row-status">
                {renderStatusDot(item)}
              </span>
            </div>
          ))}
          {!visibleItems.length && (
            <p className="ds-empty">{t("No data available")}</p>
          )}
        </div>
        {Number(totalresult) > limit && (
          <div className="ds-pagination compact">
            <Pagination
              total={totalPages}
              current={currentPage}
              pagination={goToPage}
            />
          </div>
        )}
      </aside>

      <section className="ds-detail-panel">
        <div className="ds-detail-head">
          <button
            type="button"
            className="ds-detail-back"
            onClick={closeDetail}
          >
            <ArrowForwardIosIcon fontSize="small" />
            {t("Information")}
          </button>
          <div className="ds-detail-actions">
            {details?.Status === 2 && (
              <button
                type="button"
                className="ds-outline-btn"
                data-bs-toggle="modal"
                data-bs-target="#delete-listedModal"
                onClick={() => setConfirmAction("reserve")}
              >
                {t("Remove Reserve")}
              </button>
            )}
            {details?.Status !== 2 && (
              <>
                <button
                  type="button"
                  className="ds-detail-edit-btn"
                  aria-label={t("Edit")}
                  // disabled={!details}
                  disabled={details?.Status !== 1}
                  onClick={() =>
                    navigate("/app/inventory/createColorStone", {
                      state: { editColorStoneId: detailId },
                    })
                  }
                >
                  <EditOutlinedIcon fontSize="small" />
                </button>
                <Link
                  className={`ds-primary-btn ${details?.Status === 1 ? "" : "is-disabled"}`}
                  to="/app/inventory/createColorStoneReserve"
                  state={{ colorStoneId: detailId }}
                  onClick={(e) => {
                    if (details?.Status !== 1) e.preventDefault();
                  }}
                >
                  {t("Reserve")}
                </Link>
              </>
            )}
          </div>
        </div>

        {detailLoading && !details ? (
          <p className="ds-empty">{t("Loading...")}</p>
        ) : details ? (
          <div className="ds-detail-body">
            <div className="ds-detail-summary">
              <div className="ds-detail-info">
                <h6 className="ds-detail-title">{detailTitle}</h6>
                <dl className="ds-detail-dl">
                  <dt>{t("Product ID")}</dt>
                  <dd>{details.ProductID ?? ""}</dd>
                  <dt>{t("Stock Id")}</dt>
                  <dd className="ds-detail-inline">
                    {details.StockID ?? ""}
                    {/* {renderStatusBadge(details)} */}
                    <div style={{ marginLeft: "0px" }}>
                      {renderStatusDot(details)}
                    </div>
                    {/* {renderStatusDot(details)} */}
                  </dd>
                  <dt>{t("Price")}</dt>
                  <dd>{details.Price ?? ""}</dd>
                  {/* <dt>{t('Report')}</dt> */}
                  <dt className="ds-detail-report">
                    {t("Report")}
                    {certificateImage && (
                      <a
                        className="ds-detail-cert-img"
                        href={certificateImage}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={certificateImage} alt={t("Certificate")} />
                      </a>
                    )}
                  </dt>
                  <dd className="ds-detail-inline">
                    {/* {details.CertificationUrl ? (
                      <a className="ds-link" href={details.CertificationUrl} target="_blank" rel="noreferrer">
                        {details.Certification}
                      </a>
                    ) : (
                      <span className="ds-link">{details.Certification ?? ''}</span>
                    )} */}
                    {detailCert.url ? (
                      <a
                        className="ds-link"
                        href={detailCert.url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {detailCert.number}
                      </a>
                    ) : (
                      <span className="ds-link">{detailCert.number}</span>
                    )}
                    {detailCert.url && (
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.3713 7.62868C9.19975 6.45711 7.30025 6.45711 6.12868 7.62868L3.12868 10.6287C1.95711 11.8003 1.95711 13.6997 3.12868 14.8713C4.30025 16.0429 6.19975 16.0429 7.37132 14.8713L8.19749 14.0451M7.62868 10.3713C8.80025 11.5429 10.6997 11.5429 11.8713 10.3713L14.8713 7.37132C16.0429 6.19975 16.0429 4.30025 14.8713 3.12868C13.6997 1.95711 11.8003 1.95711 10.6287 3.12868L9.80397 3.95339"
                          stroke="#606060"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                  </dd>
                  <dt>{t("Description")}</dt>
                  <dd>{detailDescription}</dd>
                </dl>
              </div>
              <div className="ds-detail-image">
                {/* <img src={detailImage} alt={detailTitle} /> */}
                {VIDEO_URL_PATTERN.test(detailImage) ? (
                  renderPreviewMedia(detailImage, detailTitle)
                ) : (
                  <img src={detailImage} alt={detailTitle} />
                )}
              </div>
            </div>

            <h6 className="ds-detail-section">{t("Diamonds details")}</h6>
            <dl className="ds-detail-dl wide">
              {detailRows.map(([label, value]) => (
                <React.Fragment key={label}>
                  <dt>{t(label)}</dt>
                  <dd>{value ?? ""}</dd>
                </React.Fragment>
              ))}
            </dl>
          </div>
        ) : (
          <p className="ds-empty">{t("No data available")}</p>
        )}
      </section>
    </div>
  );

  return (
    <React.Fragment>
      <div className="main-body ds-page">
        <div className="ds-topbar">
          <nav className="ds-breadcrumb">
            <Link to="/app/inventory/myInventory">{t("Inventory")}</Link>
            {/* <span className="ds-breadcrumb-sep">›</span> */}
            <ArrowForwardIosIcon fontSize="small" htmlColor="#BCBCBC" />
            <span className="ds-breadcrumb-current">{t("Color Stone")}</span>
          </nav>
          <div className="ds-topbar-actions">
            <Link
              className="ds-primary-btn"
              to="/app/inventory/createColorStone"
            >
              <AddCircleOutlineIcon fontSize="small" />
              {t("Create")}
            </Link>
            {!detailId && (
              <div className="ds-more-actions" ref={moreActionsRef}>
                <button
                  type="button"
                  className="ds-more-actions-btn"
                  onClick={() => setMoreActionsOpen((o) => !o)}
                >
                  <MoreVertIcon fontSize="small" />
                  {/* {t('More actions')}
                <KeyboardArrowDownIcon fontSize="small" /> */}
                </button>
                {moreActionsOpen && (
                  <ul
                    className="ds-menu"
                    onClick={() => setMoreActionsOpen(false)}
                  >
                    {parmissiondatashow?.inventory_diamond_search?.Print && (
                      <li onClick={getprintColorStoneSearch}>
                        <PrintOutlinedIcon fontSize="small" />
                        {t("Print")}
                      </li>
                    )}
                    <li
                      data-bs-toggle="modal"
                      data-bs-target="#colorStoneExportFormatModal"
                    >
                      <FileDownloadOutlinedIcon fontSize="small" />
                      {t("Export")}
                    </li>
                    <li
                      data-bs-toggle="modal"
                      data-bs-target="#colorStoneSampleFormatModal"
                    >
                      <FileDownloadOutlinedIcon fontSize="small" />
                      {t("Sample")}
                    </li>
                    <li data-bs-toggle="modal" data-bs-target="#ImportModal">
                      <FileUploadOutlinedIcon fontSize="small" />
                      {t("Import")}
                    </li>
                    <li onClick={getshareColorStoneSearch}>
                      <ShareOutlinedIcon fontSize="small" />
                      {t("Share")}
                    </li>
                    <li
                      onMouseDown={(e) => e.stopPropagation()}
                      onClick={() => {
                        setViewMode("table");
                        setColumnsMenuOpen(true);
                      }}
                    >
                      <ViewColumnOutlinedIcon fontSize="small" />
                      {t("column")}
                    </li>
                    <li onClick={() => setShowAnalytics((o) => !o)}>
                      {showAnalytics ? (
                        <VisibilityOffOutlinedIcon fontSize="small" />
                      ) : (
                        <VisibilityOutlinedIcon fontSize="small" />
                      )}
                      {showAnalytics
                        ? t("Hide Analytics")
                        : t("Show Analytics")}
                    </li>
                    {/* <li onClick={resetAndFetchList}>
                      <RestartAltOutlinedIcon fontSize="small" />
                      {t("Reset Filters")}
                    </li> */}
                  </ul>
                )}
              </div>
            )}
          </div>
        </div>

        {detailId ? (
          renderDetailView()
        ) : (
          <>
            {showAnalytics && (
              <div className="ds-stats">
                {statCards.map((card) => (
                  <div className="ds-stat-card" key={card.label}>
                    <div>
                      <p className="ds-stat-label">{t(card.label)}</p>
                      <p className="ds-stat-value">{card.value}</p>
                    </div>
                    <span className={`ds-stat-icon tone-${card.tone}`}>
                      {card.icon}
                    </span>
                  </div>
                ))}
              </div>
            )}
            {/* <div className="ds-diamonds-list-title">{t('Color Stones List')}</div> */}

            <div className="ds-results-bar" ref={resultsRef}>
              <div className="ds-results-left">
                <div ref={limitSelectRef}>
                  <Select
                    className="limit-select short ds-limit-select"
                    classNamePrefix="ds-limit"
                    options={PAGE_SIZE_OPTIONS}
                    value={{ label: limit, value: limit }}
                    // onChange={(option) => changeLimit(option.value)}
                    onChange={(option) => {
                      setLimitMenuOpen(false);
                      changeLimit(option.value);
                    }}
                    isSearchable={false}
                    menuIsOpen={limitMenuOpen}
                    onMenuOpen={() => setLimitMenuOpen(true)}
                    onMenuClose={() => setLimitMenuOpen(false)}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
                <span className="ds-results-count">
                  {t("Result")}: {totalresult} {t("row(s)")}
                </span>
                <div className="ds-view-toggle">
                  <button
                    type="button"
                    className={viewMode === "table" ? "active" : ""}
                    onClick={() => setViewMode("table")}
                  >
                    <TableRowsOutlinedIcon fontSize="small" />
                  </button>
                  <button
                    type="button"
                    className={viewMode === "grid5" ? "active" : ""}
                    onClick={() => setViewMode("grid5")}
                  >
                    <GridOnOutlinedIcon fontSize="small" />
                  </button>
                  <button
                    type="button"
                    className={viewMode === "grid4" ? "active" : ""}
                    onClick={() => setViewMode("grid4")}
                  >
                    <WindowOutlinedIcon fontSize="small" />
                  </button>
                </div>
                {/* <button
              type="button"
              className={`ds-compare-btn ${activeTab === 'comparison' ? 'active' : ''}`}
              onClick={() =>
                setActiveTab((tab) => (tab === 'comparison' ? 'results' : 'comparison'))
              }
            >
              <CompareArrowsOutlinedIcon fontSize="small" />
              {t('Comparision')} ({comparison.length})
            </button> */}
              </div>

              <div className="ds-results-right">
                {/* {comparison.length > 0 && ( */}
                {/* {hasStockSelected && (
              <button
                type="button"
                className="ds-delete-btn"
                title={t('Delete')}
                aria-label={t('Delete')}
                data-bs-toggle="modal"
                data-bs-target="#delete-listedModal"
                onClick={() => setConfirmAction('delete')}
              >
                <img
                      
                            src={base_assets + "images/admin/icons/Delete.png"} alt="" />
              </button>
            )}
            {hasDeallocatableSelected && (
              <button
                type="button"
                className="ds-delete-btn"
                title={t('Deallocate')}
                aria-label={t('Deallocate')}
                data-bs-toggle="modal"
                data-bs-target="#deallcocat-modal"
              >
                 <img
                      src={base_assets + "images/admin/icons/Delete.png"} alt="" />
              </button>
            )} */}
                {selectionActionsEl}
                {dateFilterEl}
                {searchEl}
              </div>
            </div>

            {activeTab === "comparison" ? (
              comparison.length ? (
                renderTable(comparison, true)
              ) : (
                <p className="ds-empty">{t("Select diamonds to compare")}</p>
              )
            ) : (
              <>
                {viewMode === "table" ? (
                  renderTable(visibleItems)
                ) : (
                  <div className={`ds-grid ${viewMode}`}>
                    {visibleItems.map((item) => renderCard(item))}
                  </div>
                )}
                {!visibleItems.length && (
                  <p className="ds-empty">{t("No data available")}</p>
                )}
                {Number(totalresult) > 0 && (
                  <div className="ds-pagination">
                    <Pagination
                      total={totalPages}
                      current={currentPage}
                      pagination={goToPage}
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>

      {/* <DeleteModal statement="Reserve Daimond" handler_delete={removeReserve} /> */}
      <DeallocateModal
        deallcocation_order_close={deallocateColorStones}
        deallcocation_deallocate={deallocateColorStones}
      />
      <DeleteModal
        statement={
          // confirmAction === 'delete'
          //   ? `${comparison.filter(isStock).length} ${t(comparison.filter(isStock).length > 1 ? 'Diamonds' : 'Diamond')}`
          //   : 'Reserve Daimond'
          confirmAction === "delete"
            ? `${t(comparison.filter(isStock).length > 1 ? "Color Stones" : "Color Stone")}`
            : "Reserve Color Stone"
        }
        handler_delete={
          confirmAction === "delete" ? deleteColorStones : removeReserve
        }
      />
      <ImportExcelModal
        setImportfile={setImportfile}
        readExcel={readExcel}
        importfile={importfile}
      />
      <div
        className="modal fade common-modal"
        id="colorStoneSampleFormatModal"
        tabIndex={-1}
        aria-labelledby="colorStoneSampleFormatModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img
                className="common-modal-exclamation-img"
                src={base_assets + "images/icons/exclamation-mark-green.png"}
                alt=""
              />
              <p
                className="modal-content-text mb-2"
                id="colorStoneSampleFormatModalLabel"
              >
                {t("Export format")}
              </p>
              <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="colorStoneSampleFormat"
                    value="xlsx"
                    checked={colorStoneSampleFormat === "xlsx"}
                    onChange={() => setColorStoneSampleFormat("xlsx")}
                  />
                  {t("Excel (.xlsx)")}
                </label>
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="colorStoneSampleFormat"
                    value="csv"
                    checked={colorStoneSampleFormat === "csv"}
                    onChange={() => setColorStoneSampleFormat("csv")}
                  />
                  {t("CSV")}
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn modal-content-yes"
                data-bs-dismiss="modal"
                onClick={() => SampleExcel(colorStoneSampleFormat)}
              >
                {t("Download")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade common-modal"
        id="colorStoneExportFormatModal"
        tabIndex={-1}
        aria-labelledby="colorStoneExportFormatModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img
                className="common-modal-exclamation-img"
                src={base_assets + "images/icons/exclamation-mark-green.png"}
                alt=""
              />
              <p className="modal-content-text mb-2">{t("Export format")}</p>
              <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="colorStoneExportFormat"
                    value="xlsx"
                    checked={colorStoneExportFormat === "xlsx"}
                    onChange={() => setColorStoneExportFormat("xlsx")}
                  />
                  {t("Excel (.xlsx)")}
                </label>
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="colorStoneExportFormat"
                    value="csv"
                    checked={colorStoneExportFormat === "csv"}
                    onChange={() => setColorStoneExportFormat("csv")}
                  />
                  {t("CSV")}
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn modal-content-yes"
                data-bs-dismiss="modal"
                onClick={() => callexportrequest(colorStoneExportFormat)}
              >
                {t("Export")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <SocialModal shareUrl={socialurl} shareloader={shareloader} />
      <TableColumnModal></TableColumnModal>
    </React.Fragment>
  );
};

export default ColorStoneSearch;
